import React, { useState } from 'react';
import { Box, Popover } from '@material-ui/core';
import { GridCellParams } from '@material-ui/x-grid';
import { makeStyles } from '@material-ui/core/styles';
import BaseChip from 'components/form/BaseChip';
import TagsCell from './layout/TagsCell';

const MORE_TAGS_CHIP_WIDTH = 46;

const useStyles = makeStyles((theme) => ({
  popover: {
    pointerEvents: 'none',
    '& .MuiBox-root': {
    },
  },
}));

export default function tagsExtendedCell(params: GridCellParams, width:number = 230) {
  if (params?.value === '-' || params?.value === '') {
    return '';
  }
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const tags = Array.isArray(params) ? params : (Array.isArray(params.value) ? params.value : params?.value?.split(','));
  const tagWidths: number[] = tags?.map((tag) => tag.length * 8 + 38) || [];
  const isLong = tagWidths.reduce((acc, tagWidth) => acc + tagWidth, 0) > width;
  let usedWidth = MORE_TAGS_CHIP_WIDTH;
  const visibleCount = isLong
    ? tagWidths.findIndex((tagWidth) => {
      usedWidth += tagWidth;
      return usedWidth > width;
    })
    : tagWidths.length;

  const handlePopoverOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const cellContent = tags?.map((t) => (
    <Box key={t}>
      <TagsCell tags={[t] as string[]} />
    </Box>
  ));

  return (
    <div
      style={{
        display: 'flex',
        gap: '5px',
      }}
      data-long={isLong}
      onMouseEnter={handlePopoverOpen}
      onMouseLeave={handlePopoverClose}
    >
      {isLong ? cellContent.slice(0, visibleCount) : cellContent}
      {isLong && (
        <Box>
          <BaseChip size="small" label={`+${tags.length - visibleCount}`} inTextField />
        </Box>
      )}
      {isLong && (
        <Popover
          id="mouse-over-popover"
          className={classes.popover}
          classes={{
            paper: classes.paper,
          }}
          open={open}
          anchorEl={anchorEl}
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'left',
          }}
          transformOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
          }}
          onClose={handlePopoverClose}
          disableRestoreFocus
        >
          <div className="tags-extended-cell" style={{ width: width - 50 }}>
            {cellContent}
          </div>
        </Popover>
      )}
    </div>
  );
}
